// assets/autodefinidos.js

/**
 * Autodefinidos interactivos para Shopify Dawn.
 * Soporta índice alojado en página HTML o texto plano.
 */

let puzzleData = null;

function initAutodefinidos() {
  const indexUrl = window.autodefinidosIndexUrl;
  const selector = document.getElementById('autodefinido-selector');
  const errorEl = document.getElementById('error-message');
  if (!indexUrl) {
    errorEl.textContent = 'Error: URL de índice no definida.';
    return;
  }

  fetch(indexUrl)
    .then(res => {
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      return res.text();
    })
    .then(htmlText => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      let rawText = '';
      const cont = doc.querySelector('#indice-autodefinidos');
      if (cont) {
        rawText = cont.innerText;
      } else {
        const rte = doc.querySelector('.rte');
        rawText = rte ? rte.innerText : doc.body.innerText;
      }
      rawText = rawText.trim().replace(/\r?\n/g, ' ');
      console.log('🔍 rawText:', rawText);
      return rawText;
    })
    .then(text => {
      const items = text.split(';').map(i => i.trim()).filter(Boolean);
      console.log('🔍 itemsSplit:', items);
      const entries = items.map(item => {
        const idx = item.indexOf(',');
        if (idx < 0) return null;
        const name = item.slice(0, idx).trim();
        const url = item.slice(idx + 1).trim();
        return { name, url };
      }).filter(e => e && e.name && e.url);
      console.log('🔍 parsedEntries:', entries);
      if (entries.length === 0) throw new Error('No se encontraron entradas en el índice.');
      selector.innerHTML = '<option value="">-- Elige uno --</option>';
      entries.forEach(e => {
        const opt = document.createElement('option');
        opt.value = e.url;
        opt.textContent = e.name;
        selector.appendChild(opt);
      });
    })
    .catch(err => {
      console.error('Init Autodefinidos:', err);
      document.getElementById('error-message').textContent =
        `No se pudo cargar la lista de autodefinidos: ${err.message}`;
    });
}

window.cargarAutodefinido = function() {
  const selector = document.getElementById('autodefinido-selector');
  const container = document.getElementById('autodefinido-container');
  const errorEl = document.getElementById('error-message');
  const url = selector.value;
  container.innerHTML = '';
  errorEl.textContent = '';
  if (!url) {
    errorEl.textContent = 'Por favor selecciona un autodefinido.';
    return;
  }
  fetch(url)
    .then(res => {
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      return res.text();
    })
    .then(text => {
      puzzleData = parsePuzzle(text);
      renderPuzzle(puzzleData, container);
      bindInteraction(puzzleData, container);
    })
    .catch(err => {
      console.error('Cargar Autodefinido:', err);
      errorEl.textContent = `Error al cargar el autodefinido: ${err.message}`;
    });
};

window.reiniciarAutodefinido = function() {
  const container = document.getElementById('autodefinido-container');
  const errorEl = document.getElementById('error-message');
  errorEl.textContent = '';
  if (!puzzleData) return;
  renderPuzzle(puzzleData, container);
  bindInteraction(puzzleData, container);
};

document.addEventListener('DOMContentLoaded', initAutodefinidos);

// --- Funciones internas para parsear y renderizar ---
function parsePuzzle(text) {
  const lines = text.split(/\r?\n/).map(l => l.trim());
  let ancho = 0, alto = 0, section = '';
  const celdas = [];
  const definiciones = { horizontales: [], verticales: [] };
  lines.forEach(line => {
    if (!line) return;
    if (line.startsWith('ANCHO')) ancho = parseInt(line.split(':')[1]);
    else if (line.startsWith('ALTO')) alto = parseInt(line.split(':')[1]);
    else if (line === 'CELDAS:') section = 'celdas';
    else if (line === 'HORIZONTALES:') section = 'horizontales';
    else if (line === 'VERTICALES:') section = 'verticales';
    else if (section === 'celdas') {
      celdas.push(line.split(',').map(ch => ch));
    } else if (['horizontales','verticales'].includes(section)) {
      const [numPart, rest] = line.split('|');
      const match = rest.match(/\((\d+),(\d+)\)\s*([^:]+):\s*(\S+)/);
      if (match) {
        const dir = section;
        const num = parseInt(numPart);
        const row0 = parseInt(match[1]) - 1;
        const col0 = parseInt(match[2]) - 1;
        const clue = match[3];
        const answer = match[4].toUpperCase();
        const cells = [];
        for (let i = 0; i < answer.length; i++) {
          const r = row0 + (dir === 'verticales' ? i : 0);
          const c = col0 + (dir === 'horizontales' ? i : 0);
          cells.push({ r, c });
        }
        definiciones[dir].push({ num, clue, answer, cells });
      }
    }
  });
  return { ancho, alto, celdas, definiciones };
}

function renderPuzzle(puzzle, container) {
  const { ancho, alto, celdas, definiciones } = puzzle;
  container.innerHTML = '';
  const table = document.createElement('table');
  table.className = 'autodefinido-grid';
  for (let r = 0; r < alto; r++) {
    const tr = document.createElement('tr');
    for (let c = 0; c < ancho; c++) {
      const td = document.createElement('td');
      if (celdas[r][c] === '#') td.className = 'black-cell';
      else {
        const inp = document.createElement('input');
        inp.type = 'text'; inp.maxLength = 1;
        inp.dataset.row = r; inp.dataset.col = c;
        td.appendChild(inp);
      }
      tr.appendChild(td);
    }
    table.appendChild(tr);
  }
  const cluesDiv = document.createElement('div');
  cluesDiv.className = 'autodefinido-clues';
  ['horizontales','verticales'].forEach(dir => {
    const sec = document.createElement('div');
    sec.className = `clue-section ${dir}`;
    const h3 = document.createElement('h3');
    h3.textContent = dir.charAt(0).toUpperCase()+dir.slice(1);
    sec.appendChild(h3);
    const ol = document.createElement('ol');
    definiciones[dir].forEach(def => {
      const li = document.createElement('li');
      li.id = `clue-${dir}-${def.num}`;
      li.textContent = `${def.num}. ${def.clue}`;
      ol.appendChild(li);
    });
    sec.appendChild(ol);
    cluesDiv.appendChild(sec);
  });
  container.appendChild(table);
  container.appendChild(cluesDiv);
}

function bindInteraction(puzzle, container) {
  const inputs = container.querySelectorAll('input');
  inputs.forEach(inp => {
    inp.addEventListener('focus', () => {
      clearActiveClues(container);
      const r = +inp.dataset.row, c = +inp.dataset.col;
      ['horizontales','verticales'].forEach(dir => {
        puzzle.definiciones[dir].forEach(def => {
          def.cells.forEach(cell => {
            if (cell.r===r && cell.c===c) {
              const el = container.querySelector(`#clue-${dir}-${def.num}`);
              if(el) el.classList.add('active-clue');
            }
          });
        });
      });
    });
    inp.addEventListener('blur', () => clearActiveClues(container));
    inp.addEventListener('keydown', e => {
      const r = +inp.dataset.row, c = +inp.dataset.col;
      let next;
      if (e.key==='ArrowRight') next=getInput(container,r,c+1);
      if (e.key==='ArrowLeft') next=getInput(container,r,c-1);
      if (e.key==='ArrowDown') next=getInput(container,r+1,c);
      if (e.key==='ArrowUp') next=getInput(container,r-1,c);
      if (next) { e.preventDefault(); next.focus(); }
    });
    inp.addEventListener('input', () => {
      const val = inp.value.toUpperCase(); inp.value = val;
      const r = +inp.dataset.row, c = +inp.dataset.col;
      let correct = true;
      ['horizontales','verticales'].forEach(dir => {
        puzzle.definiciones[dir].forEach(def => {
          def.cells.forEach((cell,i) => {
            if(cell.r===r && cell.c===c && def.answer[i]!==val) correct=false;
          });
        });
      });
      inp.classList.toggle('cell-correct', val && correct);
      inp.classList.toggle('cell-wrong', val && !correct);
    });
  });
}

function getInput(container, r, c) {
  return container.querySelector(`input[data-row='${r}'][data-col='${c}']`);
}

function clearActiveClues(container) {
  container.querySelectorAll('.active-clue').forEach(el => el.classList.remove('active-clue'));
}

